import { isNotDefined } from '@sgme/fp';

import { optionRepriceQuote } from '@/store/blotter/workflows/cashRepriceQuote/action.ts';
import { initiateCheckFlexiForwardByTradeCapture } from '@/store/flexi-forward/api';
import { generateEmptyFlexiForwardTile } from '@/store/flexi-forward/helpers/tile.ts';
import { selectFlexiForwardTile } from '@/store/flexi-forward/selectors/tile.ts';
import type { StartAppListening } from '@/store/listenerMiddleware.ts';

export const registerOpenBlotterFlexiForwardTradeCaptureListener = (startAppListening: StartAppListening) => {
  startAppListening({
    actionCreator: optionRepriceQuote,
    effect: async (action, api) => {
      const state = api.getState();

      const { tileId, productType } = action.payload;
      const flexi = selectFlexiForwardTile(state, tileId);

      if (isNotDefined(flexi) || productType !== 'FlexiForward') {
        return;
      }

      const { rfs: _, ...tilePropertiesWithoutRfs } = flexi.properties;

      const newFlexiForwardTile = generateEmptyFlexiForwardTile(tileId, tilePropertiesWithoutRfs, flexi.clientId);

      api.dispatch(initiateCheckFlexiForwardByTradeCapture({ tileId, ...newFlexiForwardTile }));
    },
  });
};
